import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from './cx';

export interface ErrorMessageProps {
  id?: string;
  className?: string;
  children: ReactNode;
}

/** govuk/components/error-message – with the visually hidden "Chyba:" / "Error:" prefix. */
export function ErrorMessage({ id, className, children }: ErrorMessageProps) {
  const { t } = useTranslation();
  return (
    <span id={id} className={cx('govuk-error-message', className)}>
      <span className="govuk-visually-hidden">{t('common.errorPrefix')}</span> {children}
    </span>
  );
}
